<template>
  <div class="p-5 pt-1">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <div class="grid grid-cols-5 gap-8 mt-6">
      <div class="col-span-3">
        <div class="bg-white rounded-2xl py-8 px-4 h-full">
          <div class="flex flex-wrap flex-row items-center justify-start">
            <div class="flex flex-col w-1/2 px-4">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                Mine Market ID
              </label>
              <vs-input
                class="min-w-full"
                placeholder="Enter mine market ID"
                v-model="form.mine_tug_id.value"
                :class="{ 'is-not-valid': !form.mine_tug_id.isValid }"
                :disabled="isDetail()"
              />
            </div>
            <div class="flex flex-col w-1/2 px-4">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                Tugboat Name
              </label>
              <vs-input
                class="min-w-full"
                placeholder="Enter tugboat name"
                v-model="form.name.value"
                :class="{ 'is-not-valid': !form.name.isValid }"
                :disabled="isDetail()"
              />
            </div>
            <div class="flex flex-col w-1/2 px-4 pt-5">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                Alias Name
              </label>
              <vs-input
                class="min-w-full"
                placeholder="Enter alias name"
                v-model="form.gps_name.value"
                :class="{ 'is-not-valid': !form.gps_name.isValid }"
                :disabled="isDetail()"
              />
            </div>
            <div class="flex flex-col w-1/2 px-4 pt-5">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                Horsepower
              </label>
              <select-with-search
                hide-search
                class="min-w-full"
                placeholder="Select horsepower"
                v-model="form.horse_power_id.value"
                :class="{ 'is-not-valid': !form.horse_power_id.isValid }"
                :disabled="isDetail()"
                :options="options.horsepower"
              />
            </div>
            <div class="flex flex-col w-1/2 px-4 pt-5">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                Owner
              </label>
              <select-with-search
                class="min-w-full"
                placeholder="Select owner"
                v-model="form.owner_id.value"
                :class="{ 'is-not-valid': !form.owner_id.isValid }"
                :disabled="isDetail()"
                :options="options.owner"
              />
            </div>
            <div class="flex flex-col w-1/2 px-4 pt-5">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                Mobile IMAI
              </label>
              <vs-input
                class="min-w-full"
                placeholder="Enter mobile IMAI"
                v-model="form.mobile_imai.value"
                :disabled="isDetail()"
              />
            </div>
            <div class="flex flex-col w-1/2 px-4 pt-5">
              <label class="inline-block text-sm font-semibold text-grey p-0 mb-2">
                IMEI Number
              </label>
              <vs-input
                class="min-w-full"
                placeholder="Enter imei number"
                v-model="form.imei.value"
                :disabled="isDetail()"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-2">
        <div class="bg-white rounded-2xl p-6">
          <div class="image-wrapper">
            <input
              ref="inputImage"
              class="hidden"
              type="file"
              accept="image/*"
              @input="imageToBase64"
            >
            <img
              :class="{ 'image': !!form.image_base64.value }"
              :src="form.image_base64.value || require('@/assets/shipo-default-image.png')"
            >
            <div
              v-if="!isDetail()"
              :class="[!!form.image_base64.value ? 'bg-icon delete' : 'bg-icon']"
              @click="!!form.image_base64.value ? clearImage() : $refs.inputImage.click()"
            >
              <img :src="require(`@/assets/shipo-icon-${!!form.image_base64.value ? 'delete' : 'edit'}.svg`)">
            </div>
          </div>
        </div>
        <div
          v-if="!isCreate()"
          class="flex flex-wrap flex-row items-center justify-between bg-white rounded-2xl p-6 mt-8"
        >
          <span class="font-semibold">Is Active</span>
          <vs-switch
            v-model="isActive"
            color="secondary"
            :disabled="!isUserCanAccessMenu(permission.name, 'is_active')"
          />
        </div>
      </div>
    </div>
    <div class="mt-6 px-3 flex items-center justify-end">
      <vs-button
        class="button"
        type="border"
        color="secondary"
        @click="$router.push({ name: 'SettingsTugManagementList' })"
      >
        {{ isDetail() ? 'Back' : 'Cancel' }}
      </vs-button>
      <vs-button
        v-if="!isDetail()"
        class="button shadow-secondary ml-6"
        color="secondary"
        @click="isCreate() ? postTugManagement() : putTugManagement()"
      >
        {{ isCreate() ? 'Submit' : 'Save' }}
      </vs-button>
      <vs-button
        v-if="isDetail() && isUserCanAccessMenu(permission.name, 'edit')"
        class="button shadow-secondary ml-6"
        color="secondary"
        @click="$router.push({ name: 'SettingsTugManagementEdit', params: { id: $route.params.id || tugManagementId } })"
      >
        Edit
      </vs-button>
    </div>
    <pop-up
      :active.sync="popUp"
      @close="$router.push({ name: 'SettingsTugManagementList' })"
      @ok="$router.push({ name: 'SettingsTugManagementList' })"
    >
      You have successfully {{ isCreate() ? 'add' : 'save' }} tugboat
    </pop-up>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PopUp from '@/components/popUp'
import SelectWithSearch from '@/components/selectWithSearch'
import { PAGE_TITLE } from '@/fixtures/Constants'

export default {
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  components: {
    PopUp,
    SelectWithSearch
  },
  data() {
    return {
      popUp: false,
      isActive: true,
      form: {
        mine_tug_id: {
          isValid: true,
          value: null
        },
        name: {
          isValid: true,
          value: null
        },
        gps_name: {
          isValid: true,
          value: null
        },
        horse_power_id: {
          isValid: true,
          value: null
        },
        owner_id: {
          isValid: true,
          value: null
        },
        mobile_imai: {
          value: null
        },
        imei: {
          value: null
        },
        image_base64: {
          value: null
        }
      },
      options: {
        horsepower: [],
        owner: []
      }
    }
  },
  computed: {
    ...mapGetters({
      owners: 'TugManagement/owners',
      horsePowers: 'TugManagement/horsePowers',
      tugManagementId: 'TugManagement/tugManagementId',
      tugManagementDetail: 'TugManagement/tugManagementDetail'
    }),
    mobileImai() {
      return this.form.mobile_imai.value
    },
    imeiNumber() {
      return this.form.imei.value
    },
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    owners: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.owner = val.map(item => ({ text: item.owner_name, value: item.owner_id }))
        }
      }
    },
    horsePowers: {
      handler(val) {
        if (!this.isEmpty(val)) {
          this.options.horsepower = val.map(item => ({ text: item.horse_power, value: item.horse_power_id }))
        }
      }
    },
    tugManagementDetail: {
      handler(val) {
        if (val) {
          Object.keys(this.form).forEach(key => {
            this.form[key].value = val[key]
          })
          this.form.image_base64.value = val.image_base64
            ? Buffer.from(val.image_base64, 'binary').toString()
            : null
          this.isActive = val.active
        }
      }
    },
    mobileImai: {
      handler(val) {
        if (val) {
          this.form.mobile_imai.value = val.replace(/[^0-9.]/g, "")
        }
      }
    },
    imeiNumber: {
      handler(val) {
        if (val) {
          this.form.imei.value = val.replace(/[^0-9.]/g, "")
        }
      }
    }
  },
  async mounted() {
    await this.fetchOwners()
    await this.fetchHorsePowers()
    if (!this.isCreate()) {
      await this.fetchTugManagementDetail()
    }
  },
  methods: {
    async fetchOwners() {
      try {
        await this.$store.dispatch('TugManagement/fetchOwners')
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Owner, please try again')
      }
    },
    async fetchHorsePowers() {
      try {
        await this.$store.dispatch('TugManagement/fetchHorsePowers')
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch Owner, please try again')
      }
    },
    async fetchTugManagementDetail() {
      try {
        await this.$store.dispatch('TugManagement/fetchTugManagementDetail', this.$route.params.id || this.tugManagementId)
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch detail, please try again')
      }
    },
    async postTugManagement() {
      try {
        if (this.validate()) {
          this.showFailedNotification(this, 'Some fields is empty, please fill it first')
          return
        }
        await this.$store.dispatch('TugManagement/postTugManagement', {
          ...Object.keys(this.form).reduce((item, key) => {
            item[key] = this.form[key].value
            return item
          }, {}),
          owner_name: this.options.owner.find(item => item.value === this.form.owner_id.value).text,
          horse_power: this.options.horsepower.find(item => item.value === this.form.horse_power_id.value).text
        })
        this.popUp = true
      } catch ({ error }) {
        this.showFailedNotification(this, error?.message || 'Failed to submit Tug Management, please try again')
      }
    },
    async putTugManagement() {
      try {
        if (this.validate()) {
          this.showFailedNotification(this, 'Some fields is empty, please fill it first')
          return
        }
        await this.$store.dispatch('TugManagement/putTugManagement', {
          id: this.$route.params.id || this.tugManagementId,
          form: {
            ...Object.keys(this.form).reduce((item, key) => {
              item[key] = this.form[key].value
              return item
            }, {}),
            owner_name: this.options.owner.find(item => item.value === this.form.owner_id.value).text,
            horse_power: this.options.horsepower.find(item => item.value === this.form.horse_power_id.value).text,
            active: this.isActive
          }
        })
        this.popUp = true
      } catch ({ error }) {
        this.showFailedNotification(this, error?.message || 'Failed to save Tug Management, please try again')
      }
    },
    isCreate() {
      return this.$route.name.includes('Create')
    },
    isDetail() {
      return this.$route.name.includes('Detail')
    },
    imageToBase64(e) {
      const file = e.target.files || e.dataTransfer.files || this.$refs.inputImage.files
      if (file.length === 1) {
        if (file[0].size > 10485760) {
          this.showFailedNotification(this, 'Image may not be greater than 10MB')
          return
        }
        this.getBase64(file[0],({ target: { result } }) => {
          this.form.image_base64.value = result
          this.$refs.inputImage.blur()
        })
      }
    },
    getBase64(file, callback) {
      const reader = new FileReader()
      reader.onload = callback
      reader.readAsDataURL(file)
    },
    clearImage() {
      this.form.image_base64.value = null
      this.$refs.inputImage.blur()
    },
    validate() {
      Object.keys(this.form).forEach(key => {
        if (this.form[key].hasOwnProperty('isValid')) {
          this.form[key].isValid = !!this.form[key].value
        }
      })

      return Object.keys(this.form).some(key =>
        this.form[key].hasOwnProperty('isValid')
          ? !this.form[key].isValid
          : false
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @apply py-4 #{!important};
  @apply rounded-lg;
  @apply border-2;
  @apply font-semibold;
  @apply min-w-button;
  @apply text-base;
  height: calc( 1rem * 10 / 3 );

  &.shadow-secondary {
    -webkit-box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
    box-shadow: 0 8px 25px -8px rgba(var(--vs-secondary),1);
  }

  &:focus {
    @apply outline-none;
  }
}

.image-wrapper {
  @apply flex;
  @apply flex-wrap;
  @apply relative;
  @apply items-center;
  @apply justify-center;
  @apply rounded-2xl;
  background-color: #F1F1FD;
  min-height: calc(128px + 6.5rem);

  .image {
    @apply rounded-2xl;
    @apply w-full;
  }
}

.bg-icon {
  @apply absolute;
  @apply cursor-pointer;
  @apply rounded-lg;
  @apply w-8;
  @apply h-8;
  top: 1rem;
  right: 1rem;
  background-color: rgba(252, 219, 208, 0.36);

  &.delete {
    background-color: rgba(255, 99, 123, 0.16);
  }
}

.is-not-valid {
  /deep/.vs-con-input,
  /deep/.mx-input-wrapper,
  /deep/.bg-accent-multiselect {
    @apply rounded-lg;
    outline: 2px solid #ff647c;
  }
}
</style>
